var H = Object.defineProperty;
var L = (t, e, o) => e in t ? H(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var m = (t, e, o) => (L(t, typeof e != "symbol" ? e + "" : e, o), o);
import { defineComponent as w, openBlock as c, createElementBlock as l, normalizeClass as b, createElementVNode as v, toDisplayString as $, Fragment as O, renderList as B, withModifiers as P, resolveComponent as E, normalizeStyle as S, createCommentVNode as y, createBlock as M } from "vue";
var k = /* @__PURE__ */ ((t) => (t.leftTop = "leftTop", t.leftCenter = "leftCenter", t.leftBottom = "leftBottom", t.rightTop = "rightTop", t.rightCenter = "rightCenter", t.rightBottom = "rightBottom", t.centerTop = "centerTop", t.centerCenter = "centerCenter", t.centerBottom = "centerBottom", t))(k || {});
const a = {
  simple: "simple",
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
  async: "async",
  confirm: "confirm",
  prompt: "prompt"
}, j = w({
  props: ["toast"],
  data() {
    return {
      isPromptFocused: !1
    };
  },
  methods: {
    valueChanged(t) {
      this.toast.value = t.target.value, this.toast.eventEmitter.emit("input");
    }
  }
}), C = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [i, n] of e)
    o[i] = n;
  return o;
}, N = ["id"], I = ["for"], R = { class: "snotifyToast__input__labelContent" };
function V(t, e, o, i, n, s) {
  return c(), l("span", {
    class: b(["snotifyToast__input", { "snotifyToast__input--filled": t.isPromptFocused }])
  }, [
    v("input", {
      onInput: e[0] || (e[0] = (...r) => t.valueChanged && t.valueChanged(...r)),
      class: "snotifyToast__input__field",
      type: "text",
      id: t.toast.id,
      onFocus: e[1] || (e[1] = (r) => t.isPromptFocused = !0),
      onBlur: e[2] || (e[2] = (r) => t.isPromptFocused = !!t.toast.value.length)
    }, null, 40, N),
    v("label", {
      class: "snotifyToast__input__label",
      for: t.toast.id
    }, [
      v("span", R, $(t.toast.config.placeholder), 1)
    ], 8, I)
  ], 2);
}
const q = /* @__PURE__ */ C(j, [["render", V]]), G = w({
  props: ["toast"],
  methods: {
    remove() {
      this.$snotify.remove(this.toast.id);
    }
  }
}), J = { class: "snotifyToast__buttons" }, K = ["onClick"];
function Q(t, e, o, i, n, s) {
  return c(), l("div", J, [
    (c(!0), l(O, null, B(t.toast.config.buttons, (r, h) => (c(), l("button", {
      type: "button",
      key: h,
      class: b([
        { "snotifyToast__buttons--bold": r.bold },
        r.className
      ]),
      onClick: P((f) => r.action ? r.action(t.toast) : t.remove(), ["prevent", "stop"])
    }, $(r.text), 11, K))), 128))
  ]);
}
const U = /* @__PURE__ */ C(G, [["render", Q]]), W = w({
  components: {
    SnotifyPrompt: q,
    SnotifyButton: U
  },
  props: ["toastData"],
  emits: ["stateChanged"],
  data() {
    return {
      toast: this.toastData,
      animationFrame: 0,
      state: {
        paused: !1,
        progress: 0,
        animation: "",
        isDestroying: !1,
        promptType: a.prompt
      }
    };
  },
  computed: {
    toastTitle() {
      const t = this.toast.title;
      return t.length > this.toast.config.titleMaxLength ? t.slice(0, this.toast.config.titleMaxLength) : t;
    },
    toastBody() {
      const t = this.toast.body;
      return t.length > this.toast.config.bodyMaxLength ? t.slice(0, this.toast.config.bodyMaxLength) : t;
    }
  },
  watch: {
    toastData: {
      handler(t) {
        this.toast = t, this.initToast();
      },
      immediate: !1
    }
  },
  methods: {
    /**
     * Initialize base toast config
     */
    initToast() {
      this.toast.config.timeout > 0 && this.startTimeout(0);
    },
    onClick() {
      this.toast.eventEmitter.emit("click"), this.toast.config.closeOnClick && this.$snotify.remove(this.toast.id);
    },
    onMouseEnter() {
      this.toast.eventEmitter.emit("mouseenter"), this.toast.config.pauseOnHover && (this.state.paused = !0);
    },
    onMouseLeave() {
      this.toast.config.pauseOnHover && this.toast.config.timeout && (this.state.paused = !1, this.startTimeout(this.toast.config.timeout * this.state.progress)), this.toast.eventEmitter.emit("mouseleave");
    },
    /**
     * Remove toast completely after animation
     */
    onExitTransitionEnd() {
      this.state.isDestroying || (this.initToast(), this.toast.eventEmitter.emit("shown"));
    },
    startTimeout(t = 0) {
      const e = performance.now(), o = () => {
        this.animationFrame = requestAnimationFrame((i) => {
          const n = i + t - e, s = Math.min(n / this.toast.config.timeout, 1);
          this.state.paused ? cancelAnimationFrame(this.animationFrame) : n < this.toast.config.timeout ? (this.state.progress = s, o()) : (this.state.progress = 1, cancelAnimationFrame(this.animationFrame), this.$snotify.emitter.emit("remove", this.toast.id));
        });
      };
      o();
    },
    /**
     * Trigger beforeDestroy lifecycle. Removes toast
     */
    onRemove() {
      this.state.isDestroying = !0, this.$emit("stateChanged", "beforeHide"), this.toast.eventEmitter.emit("beforeHide"), this.state.animation = this.toast.config.animation.exit, setTimeout(() => {
        this.$emit("stateChanged", "hidden"), this.state.animation = "snotifyToast--out", this.toast.eventEmitter.emit("hidden"), setTimeout(
          () => this.$snotify.remove(this.toast.id, !0),
          this.toast.config.animation.time / 2
        );
      }, this.toast.config.animation.time / 2);
    }
  },
  created() {
    this.$snotify.emitter.on("remove", (t) => {
      this.toast.id === t && this.onRemove();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.toast.eventEmitter.emit("mounted"), this.state.animation = "snotifyToast--in", this.$nextTick(() => {
        setTimeout(() => {
          this.$emit("stateChanged", "beforeShow"), this.toast.eventEmitter.emit("beforeShow"), this.state.animation = this.toast.config.animation.enter;
        }, this.toast.config.animation.time / 5);
      });
    });
  },
  unmounted() {
    cancelAnimationFrame(this.animationFrame), this.toast.eventEmitter.emit("destroyed");
  }
}), X = {
  key: 0,
  class: "snotifyToast__progressBar"
}, Y = {
  key: 0,
  class: "snotifyToast__title"
}, Z = {
  key: 1,
  class: "snotifyToast__body"
}, x = { key: 4 }, tt = ["src"], et = ["innerHTML"];
function it(t, e, o, i, n, s) {
  const r = E("snotify-prompt"), h = E("snotify-button");
  return c(), l("div", {
    class: b(["snotifyToast animated", [
      "snotify-" + t.toast.config.type,
      t.state.animation,
      t.toast.valid === void 0 ? "" : t.toast.valid ? "snotifyToast--valid" : "snotifyToast--invalid"
    ]]),
    style: S({
      "-webkit-animation-duration": t.toast.config.animation.time + "ms",
      "animation-duration": t.toast.config.animation.time + "ms",
      "-webkit-transition": t.toast.config.animation.time + "ms",
      transition: t.toast.config.animation.time + "ms"
    }),
    onClick: e[0] || (e[0] = (...f) => t.onClick && t.onClick(...f)),
    onMouseenter: e[1] || (e[1] = (...f) => t.onMouseEnter && t.onMouseEnter(...f)),
    onMouseleave: e[2] || (e[2] = (...f) => t.onMouseLeave && t.onMouseLeave(...f)),
    onAnimationend: e[3] || (e[3] = (...f) => t.onExitTransitionEnd && t.onExitTransitionEnd(...f))
  }, [
    t.toast.config.showProgressBar && t.toast.config.timeout > 0 ? (c(), l("div", X, [
      v("span", {
        class: "snotifyToast__progressBar__percentage",
        style: S({ width: t.state.progress * 100 + "%" })
      }, null, 4)
    ])) : y("", !0),
    t.toast.config.html ? (c(), l("div", {
      key: 2,
      class: "snotifyToast__inner",
      innerHTML: t.toast.config.html
    }, null, 8, et)) : (c(), l("div", {
      key: 1,
      class: b(["snotifyToast__inner", { snotifyToast__noIcon: t.toast.config.icon === !1 }])
    }, [
      t.toast.title ? (c(), l("div", Y, $(t.toastTitle), 1)) : y("", !0),
      t.toast.body ? (c(), l("div", Z, $(t.toastBody), 1)) : y("", !0),
      t.toast.config.type === t.state.promptType ? (c(), M(r, {
        key: 2,
        toast: t.toast
      }, null, 8, ["toast"])) : y("", !0),
      typeof t.toast.config.icon > "u" ? (c(), l("div", {
        key: 3,
        class: b(["snotify-icon", "snotify-icon--" + t.toast.config.type])
      }, null, 2)) : t.toast.config.icon !== !1 ? (c(), l("div", x, [
        v("img", {
          class: "snotify-icon",
          src: t.toast.config.icon
        }, null, 8, tt)
      ])) : y("", !0)
    ], 2)),
    t.toast.config.buttons ? (c(), M(h, {
      key: 3,
      toast: t.toast
    }, null, 8, ["toast"])) : y("", !0)
  ], 38);
}
const ot = /* @__PURE__ */ C(W, [["render", it]]), nt = w({
  components: {
    Toast: ot
  },
  data() {
    return {
      /**
       * Toasts array
       */
      notifications: {
        left_top: [],
        left_center: [],
        left_bottom: [],
        right_top: [],
        right_center: [],
        right_bottom: [],
        center_top: [],
        center_center: [],
        center_bottom: []
      },
      /**
       * Helper for slice pipe (maxOnScreen)
       */
      dockSize_a: 0,
      /**
       * Helper for slice pipe (maxOnScreen)
       */
      dockSize_b: 0,
      /**
       * Helper for slice pipe (maxAtPosition)
       */
      blockSize_a: 0,
      /**
       * Helper for slice pipe (maxAtPosition)
       */
      blockSize_b: 0,
      /**
       * Backdrop Opacity
       */
      backdrop: -1,
      /**
       * How many toasts with backdrop in current queue
       */
      withBackdrop: []
    };
  },
  methods: {
    getNotificationsForPos(t) {
      return this.notifications[t].slice(this.blockSize_a, this.blockSize_b);
    },
    setOptions(t) {
      var e, o;
      if (this.$snotify.config.global) {
        const i = (e = this.$snotify.config.global) == null ? void 0 : e.maxOnScreen, n = (o = this.$snotify.config.global) == null ? void 0 : o.maxAtPosition;
        this.$snotify.config.global.newOnTop ? (i && (this.dockSize_a = -i), this.dockSize_b = void 0, n && (this.blockSize_a = -n), this.blockSize_b = void 0, this.withBackdrop = t.filter(
          (s) => s.config.backdrop >= 0
        )) : (this.dockSize_a = 0, i && (this.dockSize_b = i), this.blockSize_a = 0, n && (this.blockSize_b = n), this.withBackdrop = t.filter((s) => s.config.backdrop >= 0).reverse());
      }
      this.notifications = this.splitToasts(
        t.slice(this.dockSize_a, this.dockSize_b)
      ), this.stateChanged("mounted");
    },
    // TODO: fix backdrop if more than one toast called in a row
    /**
     * Changes the backdrop opacity
     * @param {SnotifyEvent} event
     */
    stateChanged(t) {
      if (!this.withBackdrop.length) {
        this.backdrop >= 0 && (this.backdrop = -1);
        return;
      }
      switch (t) {
        case "mounted":
          this.backdrop < 0 && (this.backdrop = 0);
          break;
        case "beforeShow":
          const e = this.withBackdrop[this.withBackdrop.length - 1].config.backdrop;
          e && (this.backdrop = e);
          break;
        case "beforeHide":
          this.withBackdrop.length === 1 && (this.backdrop = 0);
          break;
        case "hidden":
          this.withBackdrop.length === 1 && (this.backdrop = -1);
          break;
      }
    },
    /**
     * Split toasts toasts into different objects
     * @param {SnotifyToast[]} toasts
     * @returns {SnotifyNotifications}
     */
    splitToasts(t) {
      const e = {};
      for (const o in k)
        k.hasOwnProperty(o) && (e[k[o]] = []);
      return t.forEach((o) => {
        e[o.config.position].push(o);
      }), e;
    }
  },
  created() {
    this.$snotify.emitter.on("snotify", (t) => {
      this.setOptions(t);
    });
  }
});
function st(t, e, o, i, n, s) {
  const r = E("toast");
  return c(), l("div", null, [
    t.backdrop >= 0 ? (c(), l("div", {
      key: 0,
      class: "snotify-backdrop",
      style: S({ opacity: t.backdrop })
    }, null, 4)) : y("", !0),
    (c(!0), l(O, null, B(t.notifications, (h, f) => (c(), l("div", {
      class: b(["snotify", "snotify-" + f]),
      key: f
    }, [
      (c(!0), l(O, null, B(t.getNotificationsForPos(f), (T) => (c(), M(r, {
        toastData: T,
        key: T.id,
        onStateChanged: t.stateChanged
      }, null, 8, ["toastData", "onStateChanged"]))), 128))
    ], 2))), 128))
  ]);
}
const at = /* @__PURE__ */ C(nt, [["render", st]]);
function A(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, o) {
    var i = t.get(e);
    i ? i.push(o) : t.set(e, [o]);
  }, off: function(e, o) {
    var i = t.get(e);
    i && (o ? i.splice(i.indexOf(o) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, o) {
    var i = t.get(e);
    i && i.slice().map(function(n) {
      n(o);
    }), (i = t.get("*")) && i.slice().map(function(n) {
      n(e, o);
    });
  } };
}
class D {
  /**
   *
   * @param {number|string} id
   * @param {string} title
   * @param {string} body
   * @param {SnotifyToastConfig} [config]
   */
  constructor(e, o, i, n) {
    /**
     * Emits {SnotifyEvent}
     */
    m(this, "eventEmitter", A());
    /**
     * Holds all subscribers because we need to unsubscribe from all before toast get destroyed
     * @private
     *
     */
    m(this, "_eventsHolder", []);
    /**
     * Toast prompt value
     */
    m(this, "value", "");
    /**
    * Toast validator
    */
    m(this, "valid");
    this.id = e, this.title = o, this.body = i, this.config = n, this.config.type === a.prompt && (this.value = ""), this.on("hidden", () => {
      this._eventsHolder.forEach((s) => {
        this.eventEmitter.off(s.event, s.action);
      });
    });
  }
  /**
  * This callback is displayed as a global member.
  * @callback action
  * @param {toast} responseCode
  * @returns {void}
  */
  /**
   * Subscribe to toast events
   * @param {String<SnotifyEvent>} event
   * @param  {SnotifyToast~action} action
   * @returns {SnotifyToast}
   */
  on(e, o) {
    return this._eventsHolder.push({ event: e, action: o }), this.eventEmitter.on(e, () => o(this)), this;
  }
}
const rt = {
  global: {
    newOnTop: !0,
    maxOnScreen: 8,
    maxAtPosition: 8,
    oneAtTime: !1,
    preventDuplicates: !1
  },
  toast: {
    timeout: 2e3,
    showProgressBar: !0,
    type: a.simple,
    closeOnClick: !0,
    pauseOnHover: !0,
    titleMaxLength: 16,
    bodyMaxLength: 150,
    backdrop: -1,
    icon: void 0,
    animation: { enter: "fadeIn", exit: "fadeOut", time: 400 },
    html: void 0,
    position: k.rightBottom
  },
  type: {
    [a.prompt]: {
      timeout: 0,
      closeOnClick: !1,
      buttons: [
        { text: "Ok", bold: !0 },
        { text: "Cancel", bold: !1 }
      ],
      placeholder: "Enter answer here...",
      type: a.prompt
    },
    [a.confirm]: {
      timeout: 0,
      closeOnClick: !1,
      buttons: [
        { text: "Ok", bold: !0 },
        { text: "Cancel", bold: !1 }
      ],
      type: a.confirm
    },
    [a.simple]: {
      type: a.simple
    },
    [a.success]: {
      type: a.success
    },
    [a.error]: {
      type: a.error
    },
    [a.warning]: {
      type: a.warning
    },
    [a.info]: {
      type: a.info
    },
    [a.async]: {
      pauseOnHover: !1,
      closeOnClick: !1,
      timeout: 0,
      showProgressBar: !1,
      type: a.async
    }
  }
};
function ct() {
  return Math.floor(Math.random() * (Date.now() - 1)) + 1;
}
function F(t) {
  return t && typeof t == "object" && !Array.isArray(t) && t !== null;
}
function _(...t) {
  const e = {};
  if (!t.length)
    return e;
  for (; t.length > 0; ) {
    const o = t.shift();
    if (F(o))
      for (const i in o)
        F(o[i]) ? e[i] = _(e[i], o[i]) : Object.assign(e, { [i]: o[i] });
  }
  return e;
}
function p(t, e, o) {
  return {
    value: function(...i) {
      return i[0].config = {
        ...i[0].config,
        type: e
      }, o.value.apply(this, i);
    }
  };
}
function d(t, e, o) {
  return e === a.async ? {
    value: function(...i) {
      let n;
      return i.length === 2 ? n = {
        title: null,
        body: i[0],
        config: null,
        action: i[1]
      } : i.length === 3 ? typeof i[1] == "string" ? n = {
        title: i[1],
        body: i[0],
        config: null,
        action: i[2]
      } : n = {
        title: null,
        body: i[0],
        config: i[2],
        action: i[1]
      } : n = {
        title: i[1],
        body: i[0],
        config: i[3],
        action: i[2]
      }, o.value.apply(this, [n]);
    }
  } : {
    value: function(...i) {
      let n;
      return i.length === 1 ? n = {
        title: null,
        body: i[0],
        config: null
      } : i.length === 3 ? n = {
        title: i[1],
        body: i[0],
        config: i[2]
      } : n = {
        title: null,
        config: null,
        body: i[0],
        [typeof i[1] == "string" ? "title" : "config"]: i[1]
      }, o.value.apply(this, [n]);
    }
  };
}
var lt = Object.defineProperty, ft = Object.getOwnPropertyDescriptor, g = (t, e, o, i) => {
  for (var n = ft(e, o), s = t.length - 1, r; s >= 0; s--)
    (r = t[s]) && (n = r(e, o, n) || n);
  return n && lt(e, o, n), n;
};
class u {
  constructor() {
    m(this, "emitter", A());
    m(this, "notifications", []);
    m(this, "config", rt);
  }
  /**
   * emit changes in notifications array
   */
  emit() {
    this.emitter.emit("snotify", this.notifications.slice());
  }
  /**
   * returns SnotifyToast object
   * @param id {Number}
   * @return {SnotifyToast|undefined}
   */
  get(e) {
    return this.notifications.find((o) => o.id === e);
  }
  /**
   * add SnotifyToast to notifications array
   * @param toast {SnotifyToast}
   */
  add(e) {
    var o;
    (o = this.config.global) != null && o.newOnTop ? this.notifications.unshift(e) : this.notifications.push(e), this.emit();
  }
  /**
   * update SnotifyToast in notifications array
   */
  update(e) {
    const o = this.notifications.findIndex((i) => i.id === e.id);
    o !== -1 && (this.notifications[o] = e, this.emit());
  }
  /**
   * If ID passed, emits toast animation remove, if ID & REMOVE passed, removes toast from notifications array
   * @param id {number}
   * @param remove {boolean}
   */
  remove(e, o) {
    if (e) {
      if (o)
        return this.notifications = this.notifications.filter(
          (i) => i.id !== e
        ), this.emit();
    } else
      return this.clear();
    this.emitter.emit("remove", e);
  }
  /**
   * Clear notifications array
   */
  clear() {
    this.notifications = [], this.emit();
  }
  button(e, o = !0, i, n = !1) {
    return {
      text: e,
      action: o ? (s) => {
        i && i(s), this.remove(s.id);
      } : i,
      bold: n
    };
  }
  /**
   * Creates toast and add it to array, returns toast id
   * @param snotify {Snotify}
   * @return {number}
   */
  create(e) {
    var n, s, r, h, f;
    if ((s = (n = this.config) == null ? void 0 : n.global) != null && s.oneAtTime && this.notifications.length !== 0 || (h = (r = this.config) == null ? void 0 : r.global) != null && h.preventDuplicates && this.notifications.filter((T) => {
      var z;
      return T.config.type === ((z = e == null ? void 0 : e.config) == null ? void 0 : z.type);
    }).length === 1)
      return;
    const o = _(
      this.config.toast,
      this.config.type ? [(f = e.config) == null ? void 0 : f.type] : null,
      e.config
    ), i = new D(
      o.id ? o.id : ct(),
      e.title ? e.title : "",
      e.body ? e.body : "",
      o
    );
    return this.add(i), i;
  }
  setDefaults(e) {
    return this.config = _(this.config, e);
  }
  simple(e) {
    return this.create(e);
  }
  success(e) {
    return this.create(e);
  }
  error(e) {
    return this.create(e);
  }
  info(e) {
    return this.create(e);
  }
  warning(e) {
    return this.create(e);
  }
  confirm(e) {
    return this.create(e);
  }
  prompt(e) {
    return this.create(e);
  }
  async(e) {
    let o = e.action;
    const i = this.create({
      title: e.title,
      body: e.body,
      config: {
        ...e.config,
        timeout: 0
      },
      html: e.html
    });
    if (i)
      return i.on(
        "mounted",
        () => {
          o().then((n) => this.mergeToast(i, n, a.success)).catch((n) => this.mergeToast(i, n, a.error));
        }
      ), i;
  }
  mergeToast(e, o, i) {
    var s, r, h;
    const n = new D(
      e.id,
      o.title || e.title,
      o.body || e.body,
      {
        ..._(
          this.config.global,
          e.config,
          ((s = this.config.toast) == null ? void 0 : s[i]) || a.info,
          { type: i },
          o.config
        ),
        timeout: ((r = o.config) == null ? void 0 : r.timeout) || ((h = this.config.toast) == null ? void 0 : h.timeout)
      }
    );
    o.html && (n.config.html = o.html), this.update(n);
  }
}
g([
  d,
  p
], u.prototype, "simple");
g([
  d,
  p
], u.prototype, "success");
g([
  d,
  p
], u.prototype, "error");
g([
  d,
  p
], u.prototype, "info");
g([
  d,
  p
], u.prototype, "warning");
g([
  d,
  p
], u.prototype, "confirm");
g([
  d,
  p
], u.prototype, "prompt");
g([
  d,
  p
], u.prototype, "async");
const mt = {
  install: (t, e = {}) => {
    const o = new u();
    o.setDefaults(e), t.config.globalProperties.$snotify = o, t.component("vue-snotify", at);
  }
};
export {
  mt as default
};
